import I18n from 'I18n';
function createAction(name) {
  return `@@form/${name}`;
}
export const ADD_EXTERNAL_URL = createAction('ADD_EXTERNAL_URL');
function addExternalUrl(url) {
  return {
    type: ADD_EXTERNAL_URL,
    url
  };
}
export function addExternalUrlToRedirectUrls(url, urlIndex) {
  const data = {
    url,
    name: I18n.text('editor.options.externalLink'),
    id: urlIndex
  };
  return dispatch => {
    dispatch(addExternalUrl(data));
  };
}